// extracted by mini-css-extract-plugin
export var changeIcon = "_63-4";
export var container = "_63-0";
export var divider = "_63-7";
export var externalLinkIcon = "_63-1";
export var green = "_63-5";
export var helpCircleIcon = "_63-3";
export var iconButton = "_63-2";
export var red = "_63-6";